export class SettingsTrustedIpsDto {
  trustedIps: string[];
  enabled: boolean;
}
